import React, { useEffect, useState } from 'react';
import { F } from './estilos';
import { formatoCabecera } from '../../utils/campanas';

const TOKEN = /(\{\{\s*[^{}\s]+\s*\}\})/;

const componente = (plantilla, tipo) =>
  (plantilla?.components || []).find((c) => (c.type || '').toUpperCase() === tipo);

const conVariables = (texto) =>
  (texto || '').split(TOKEN).map((trozo, i) =>
    TOKEN.test(trozo) ? <span key={i} style={F.varTag}>{trozo}</span> : trozo);

const iconoBoton = (tipo) => (tipo === 'URL' ? '🔗 ' : tipo === 'PHONE_NUMBER' ? '📞 ' : '↩️ ');

/** El mensaje como lo verá el destinatario: la plantilla elegida o, tras analizar, su primera fila. */
const VistaPreviaCampana = ({ plantilla, muestra, cabecera = null }) => {
  const ejemplo = muestra?.[0];
  const header = componente(plantilla, 'HEADER');
  const formato = formatoCabecera(plantilla);
  const pie = componente(plantilla, 'FOOTER');
  const botones = (componente(plantilla, 'BUTTONS')?.buttons || []).filter((b) => b.text);
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (formato !== 'IMAGE' || !cabecera) {
      setUrl(null);
      return undefined;
    }
    const creada = URL.createObjectURL(cabecera);
    setUrl(creada);
    return () => URL.revokeObjectURL(creada);
  }, [formato, cabecera]);

  const previaCabecera = () => {
    if (formato === 'IMAGE') {
      return (
        <div data-testid="previa-cabecera" style={F.previaMedia}>
          {url && cabecera ? <img src={url} alt={cabecera.name} style={F.previaMediaImg} /> : 'Imagen'}
        </div>
      );
    }
    if (formato === 'VIDEO') {
      return <div data-testid="previa-cabecera" style={F.previaMedia}>{`▶ ${cabecera?.name || ''}`.trim()}</div>;
    }
    if (formato === 'DOCUMENT') {
      return <div data-testid="previa-cabecera" style={F.previaMedia}>{`📄 ${cabecera?.name || 'Documento'}`}</div>;
    }
    if (header?.text) {
      return (
        <div data-testid="previa-cabecera" style={F.bubbleHeader}>
          {ejemplo ? ejemplo.cabecera : conVariables(header.text)}
        </div>
      );
    }
    return null;
  };

  return (
    <div data-testid="campana-vista-previa" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <span style={F.previewTitle}>Vista previa</span>
      <div style={F.phone}>
        {plantilla ? (
          <>
            <div style={F.bubble}>
              {previaCabecera()}
              <div data-testid="previa-cuerpo" style={F.bubbleBody}>
                {ejemplo ? ejemplo.cuerpo : conVariables(componente(plantilla, 'BODY')?.text)}
              </div>
              {pie?.text && <div style={F.bubbleFooter}>{pie.text}</div>}
              <div style={F.bubbleTime}>12:00</div>
            </div>
            {botones.length > 0 && (
              <div style={F.bubbleButtons}>
                {botones.map((b, i) => <div key={i} style={F.previewButton}>{iconoBoton(b.type)}{b.text}</div>)}
              </div>
            )}
          </>
        ) : (
          <div style={F.previewVacio}>Elige una plantilla para ver el mensaje.</div>
        )}
      </div>
      {ejemplo && <span style={F.ejemplo}>{`Así lo recibirá ${ejemplo.msisdn}`}</span>}
    </div>
  );
};

export default VistaPreviaCampana;
